const columns = [
    {
        field: "id",
        headerName: "Id",
        description: "id in the db",
        minWidth: 50,
        flex: 1,
    },
    {
        field: "barcode",
        headerName: "Barcode",
        minWidth: 50,
        editable: true,
        flex: 1,
    },
    {
        field: "name",
        headerName: "Name",
        minWidth: 50,
        editable: true,
        flex: 1,
    },
    {
        field: "description",
        headerName: "Description",
        minWidth: 50,
        editable: true,
        flex: 1,
    },
    // { field: "typeId", headerName: "Type", minWidth: 50, editable:true, flex: 1, },
    {
        field: "priceNormal",
        headerName: "Price",
        minWidth: 50,
        editable: true,
        type: "number",
        flex: 1,
    },
    {
        field: "priceWholesale",
        headerName: "Wholesale Price",
        minWidth: 50,
        type: "number",
        editable: true,
        flex: 1,
    },
    {
        field: "quantityRemaining",
        headerName: "Quantity Remaining",
        minWidth: 50,
        editable: true,
        flex: 1,
        type: "number",
    },
    {
        field: "minAlarmQuantity",
        headerName: "Min Alarm Quantity",
        minWidth: 50,
        editable: true,
        flex: 1,
    },
    // { field: "ExpiryDate", headerName: "Expiry Date", type: "date", minWidth: 50, editable:true, flex: 1, },
    // { field: "PurchaseDate", headerName: "Purchase Date", type: "date", minWidth: 50, editable:true, flex: 1, },
];
const addItemFormFields = [
    {
        label: "Name",
        name: "name",
        type: "text",
        placeholder: "Enter Name",
        required: true,
        width: "49%",
        validate: (value) => (value.trim() === "" ? "Name is required" : ""),
        /*
        onFieldChange: (allFields, value) => {
            const updatedFields = allFields
            updatedFields["barcode"] = value
            return updatedFields
        }
        */
    },
    {
        label: "Barcode",
        name: "barcode",
        type: "text",
        placeholder: "Enter Barcode",
        required: false,
        width: "49%",
    },
    {
        label: "Price",
        name: "priceNormal",
        type: "number",
        placeholder: "Enter Price",
        required: true,
        width: "49%",
    },
    {
        label: "Wholesale Price",
        name: "priceWholesale",
        type: "number",
        placeholder: "Enter Price",
        required: true,
        width: "49%",
    },
    {
        label: "Description",
        name: "description",
        type: "text",
        placeholder: "Enter Description",
    },

    {
        name: "typeId",
        type: "select",
        options: [
            {
                value: 1,
                label: "Normal",
            },
            {
                value: 2,
                label: "Hidden",
            },
        ],
        defaultValue: 1,
        required: true,
    },
];
const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Function to get API URI
 * created for management of API URI changes
 */
const Get_URI = (method, data = {}) => {
    switch (method) {
        case "GET":
            return `${REACT_APP_BACKEND_URL}/items?${data.queryParams}`;
        case "POST":
            return `${REACT_APP_BACKEND_URL}/items/create`;
        case "PATCH":
            return `${REACT_APP_BACKEND_URL}/items/${data.id}`;
        case "DELETE":
            return `${REACT_APP_BACKEND_URL}/items/${data.id}`;
        default:
            return "";
    }
};

export { columns, addItemFormFields, Get_URI };
